<template>
  <div>
    <MultibarChart
      :request-status="requestStatus"
      :series="rawSeries"
      :title="title"
      :item-id="itemId"
      v-bind="$attrs"
      @reload="getData"
    />
    <v-data-table
      :headers="headers"
      :items="medias"
      hide-default-footer
    />
  </div>
</template>

<script>
import MultibarChart from '@/components/cards/models/MultibarChart';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { formatNumber } from '@/utils/formatter';

export default {
  name: 'HighlightsMultibar',
  components: {
    MultibarChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    channel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      headers: [],
      medias: [],
      requestStatus: 'loading',
      rawSeries: [],
      classifiedPercentage: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getMediaService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getMediaService({
        itemId: this.itemId,
        servicePath: 'getFeaturedMedia',
        serviceParams: {
          channel: this.channel,
        },
      })
        .then(response => {
          this.rawSeries = { all: response.data };
          this.requestStatus = 'success';
          this.headers = [
            {
              text: this.$t('components.Impress.news'),
              align: 'start',
              sortable: false,
              value: 'name',
            },
            { text: this.$t('components.Impress.quotes'), value: 'total' },
            { text: this.$t('components.Impress.valoration'), value: 'valoration' },
          ];
          if (this.channel === 'Rádio' || this.channel === 'TV') {
            this.headers.push({ text: this.$t('components.Impress.minute'), value: 'footage' });

            response.data = response.data.map(res => {
              const { hours, minutes, seconds } = res.footage;
              res.footage = `${hours}h${minutes}m${seconds}s`;
              return res;
            });
          } else {
            this.headers.push({ text: this.$t('components.Impress.centage'), value: 'footage' });
          }

          this.medias = response.data.map(res => {
            res.valoration = `R$ ${formatNumber(res.valoration)}`;
            return res;
          });
          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped>
</style>
